import { Layout } from "antd";
import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { permissionName, permissionType } from "../../config/permission";
import { checkRolePermission } from "../../services/permission";
import Admin from "../Admin";
import { Country, CountryRestrictions } from "../Country";
import DeliveryLogs from "../DeliveryLogs";
import DeliveryLogsBlackhole from "../DeliveryLogsBlackhole";
import DeliveryLogsVerify from "../DeliveryLogsVerify";
import Gateway from "../Gateway";
import GatewayCountry from "../GatewayCountry";
import HeaderBar from "../HeaderBar";
// import FooterBar from '../FooterBar';
import ApproveBinding from "../ApproveBinding";
import BlackList from "../BlackList";
import GatewayCountryLogs from "../GatewayCountryLogs";
import Home from "../Home";
import InviteAdmin from "../InviteAdmin";
import Alert from "../Keyword/Alert";
import AlertWhitelist from "../Keyword/AlertWhitelist";
import AlertWhitelistMember from "../Keyword/AlertWhitelistMember";
import BlackHole from "../Keyword/Blackhole";
import LeftSide from "../LeftSide";
import { ChangePassword, Profile } from "../Me";
import MemberCountry from "../MemberCountry";
import NotFound from "../NotFound";
import OfferManagement from "../OfferManagement";
import Payment from "../Payment";
import CostListing from "../PriceManagement/CostListing";
import PrivateRoute from "../PrivateRoute";
import RevisionListing from "../RevisionPrice";
import RevisionBuilder from "../RevisionPrice/RevisionBuilder";
import RevisionDetail from "../RevisionPrice/RevisionDetail";
import SaleOrder from "../SaleOrder";
import CreateSale from "../SaleOrder/CreateSale";
import SendersDefault from "../Senders/default";
import SendersDefaultGateway from "../Senders/default-gateway";
import SendersPool from "../SendersPool";
import SignIn from "../SignIn";
import SmsLogs from "../SmsLogs";
import User from "../User";
import SmppLogs from "../SmppLog";
import SlRawLog from "../SlRawLogs";
import ViberLog from "../ViberLog";
import WhitelistUrl from "../Keyword/WhitelistURL";
import SmppMonitor from "../SmppMonitor";

class MyApp extends Component {
  state = {
    canReadHome: false,
    canReadPayment: false,
    canReadSmsLogs: false,
    canReadGateway: false,
    canReadSendersPool: false,
    canReadSendersDefault: false,
    canReadSendersGeneric: false,
    canReadKeyword: false,
    canReadUserMgmt: false,
    canReadAdminMgmt: false,
    canReadCountry: false,
    canReadCountryRestrict: false,
    canReadBlacklistMgmt: false,
    canReadOfferMgmt: false,
    canReadRevissionPrice: false,
    canCreateRevissionPrice: false,
    canUpdateRevissionPrice: false,
    canReadPriceMgmt: false,
    canReadSalesOrder: false,
    canCreateSalesOrder: false,
    canReadFbCountry: false,
    canReadApproveBinding: false,
  };

  componentWillMount() {
    const canReadHome = checkRolePermission(
      permissionName.HOME,
      permissionType.READ
    );
    const canReadApproveBinding = checkRolePermission(
      permissionName.SALE_BINDING_REQUEST_MANAGEMENT,
      permissionType.UPDATE
    );
    const canReadPayment = checkRolePermission(
      permissionName.PAYMENT,
      permissionType.READ
    );
    const canReadSmsLogs = checkRolePermission(
      permissionName.SMS_LOG,
      permissionType.READ
    );
    const canReadGateway = checkRolePermission(
      permissionName.GATEWAY_MANAGEMENT,
      permissionType.READ
    );
    const canReadSendersPool = checkRolePermission(
      permissionName.SENDER_POOL,
      permissionType.READ
    );
    const canReadSendersDefault = checkRolePermission(
      permissionName.SENDER_DEFAULT,
      permissionType.READ
    );
    const canReadSendersGeneric = checkRolePermission(
      permissionName.SENDER_GENERIC,
      permissionType.READ
    );
    const canReadKeyword = checkRolePermission(
      permissionName.KEYWORD,
      permissionType.READ
    );
    const canReadUserMgmt = checkRolePermission(
      permissionName.CUSTOMER_MANAGEMENT,
      permissionType.READ
    );
    const canReadAdminMgmt = checkRolePermission(
      permissionName.ADMIN_MANAGEMENT,
      permissionType.READ
    );
    const canReadCountry = checkRolePermission(
      permissionName.COUNTRY,
      permissionType.READ
    );
    const canReadCountryRestrict = checkRolePermission(
      permissionName.COUNTRY_RESTRICTION,
      permissionType.READ
    );
    const canReadBlacklistMgmt = checkRolePermission(
      permissionName.BLACKLIST_MANAGEMENT,
      permissionType.READ
    );
    const canReadOfferMgmt = checkRolePermission(
      permissionName.OFFER_MANAGEMENT,
      permissionType.READ
    );
    const canReadRevissionPrice = checkRolePermission(
      permissionName.REVISION_PRICE,
      permissionType.READ
    );
    const canCreateRevissionPrice = checkRolePermission(
      permissionName.REVISION_PRICE,
      permissionType.CREATE
    );
    const canUpdateRevissionPrice = checkRolePermission(
      permissionName.REVISION_PRICE,
      permissionType.UPDATE
    );
    const canReadPriceMgmt = checkRolePermission(
      permissionName.PRICE_MANAGEMENT,
      permissionType.READ
    );
    const canReadSalesOrder = checkRolePermission(
      permissionName.PAYMENT_SO,
      permissionType.READ
    );
    const canCreateSalesOrder = checkRolePermission(
      permissionName.PAYMENT_SO,
      permissionType.CREATE
    );
    const canReadFbCountry = checkRolePermission(
      permissionName.CUSTOMER_MANAGEMENT_FOBIDDEN_COUNTRY,
      permissionType.READ
    );

    this.setState({
      canReadHome,
      canReadPayment,
      canReadSmsLogs,
      canReadGateway,
      canReadSendersPool,
      canReadSendersDefault,
      canReadSendersGeneric,
      canReadKeyword,
      canReadUserMgmt,
      canReadAdminMgmt,
      canReadCountry,
      canReadCountryRestrict,
      canReadBlacklistMgmt,
      canReadOfferMgmt,
      canReadRevissionPrice,
      canCreateRevissionPrice,
      canUpdateRevissionPrice,
      canReadPriceMgmt,
      canReadSalesOrder,
      canCreateSalesOrder,
      canReadFbCountry,
      canReadApproveBinding,
    });
  }

  render() {
    return (
      <Layout>
        <BrowserRouter>
          <HeaderBar />
          <Layout style={{ minHeight: "100vh" }}>
            <LeftSide />

            <Switch>
              <Route path="/sign-in" component={SignIn} />
              <Route path="/invite" component={InviteAdmin} />

              <PrivateRoute
                path="/"
                exact
                canActivate={this.state.canReadHome}
                component={Home}
              />
              <PrivateRoute
                path="/payment/(approved|to_approve|reject)"
                canActivate={this.state.canReadPayment}
                component={Payment}
              />
              <PrivateRoute
                path="/payment"
                canActivate={this.state.canReadPayment}
                component={Payment}
              />

              <PrivateRoute
                path="/sms-logs/outbound/v2"
                canActivate={this.state.canReadSmsLogs}
                component={SmsLogs}
              />
              <PrivateRoute
                path="/sms-logs/smpp"
                canActivate={this.state.canReadSmsLogs}
                component={SmppLogs}
              />
              <PrivateRoute
                path="/sms-logs/viber"
                canActivate={this.state.canReadSmsLogs}
                component={ViberLog}
              />
              <PrivateRoute
                path="/sms-logs/outbound"
                canActivate={this.state.canReadSmsLogs}
                component={DeliveryLogs}
              />
              <PrivateRoute
                path="/sms-logs/sl-raw"
                canActivate={this.state.canReadSmsLogs}
                component={SlRawLog}
              />

              <PrivateRoute
                path="/sms-logs/verify"
                canActivate={this.state.canReadSmsLogs}
                component={DeliveryLogsVerify}
              />
              <PrivateRoute
                path="/sms-logs/blackhole"
                canActivate={this.state.canReadSmsLogs}
                component={DeliveryLogsBlackhole}
              />
              {/* <PrivateRoute path="/sms-logs/dn" component={DNLogs} /> */}

              <PrivateRoute
                path="/gateway/(sms|voice)"
                canActivate={this.state.canReadGateway}
                component={Gateway}
              />
              <PrivateRoute
                path="/gateway-management/gateway-country"
                canActivate={this.state.canReadGateway}
                component={GatewayCountry}
              />
              <PrivateRoute
                path="/gateway-management/gateway-country-logs"
                canActivate={this.state.canReadGateway}
                component={GatewayCountryLogs}
              />

              <PrivateRoute
                path="/senders/senders-pool"
                canActivate={this.state.canReadSendersPool}
                component={SendersPool}
              />
              <PrivateRoute
                path="/senders/default"
                canActivate={this.state.canReadSendersDefault}
                component={SendersDefault}
              />
              <PrivateRoute
                path="/senders/default-gateway"
                canActivate={this.state.canReadSendersGeneric}
                component={SendersDefaultGateway}
              />

              {/* <PrivateRoute path="/settings/refund" component={Refund} /> */}
              {/* <PrivateRoute path="/settings/verify-template" component={VerifyTemplate} /> */}

              {/* <PrivateRoute path="/service" component={Service} /> */}

              <PrivateRoute
                path="/keyword/blackhole"
                canActivate={this.state.canReadKeyword}
                component={BlackHole}
              />
              <PrivateRoute
                path="/keyword/alert"
                canActivate={this.state.canReadKeyword}
                component={Alert}
              />
              <PrivateRoute
                path="/keyword/alert-whitelist"
                canActivate={this.state.canReadKeyword}
                component={AlertWhitelist}
              />
              <PrivateRoute
                path="/keyword/alert-whitelist-member"
                canActivate={this.state.canReadKeyword}
                component={AlertWhitelistMember}
              />
              <PrivateRoute
                path="/keyword/keyword-whitelist-url"
                canActivate={this.state.canReadKeyword}
                component={WhitelistUrl}
              />

              <PrivateRoute
                path="/user-management/listing"
                canActivate={this.state.canReadUserMgmt}
                component={User}
              />
              <PrivateRoute
                path="/user-management/smpp-customers-monitoring"
                canActivate={this.state.canReadUserMgmt}
                component={SmppMonitor}
              />

              {/* add here to register path */}
              <PrivateRoute
                path="/approve-binding-sales-owner"
                canActivate={this.state.canReadApproveBinding} // true = show path in side bar
                component={ApproveBinding} //เอา component ApproveBinding มา render ใน path ข้างบน
              />

              <PrivateRoute
                path="/user-management/member-country/:member_id"
                canActivate={this.state.canReadFbCountry}
                component={MemberCountry}
              />

              <PrivateRoute
                path="/admin-management"
                canActivate={this.state.canReadAdminMgmt}
                component={Admin}
              />
              <PrivateRoute path="/me" canActivate={true} component={Profile} />
              <PrivateRoute
                path="/change-password"
                canActivate={true}
                component={ChangePassword}
              />

              <PrivateRoute
                path="/revision-price/country"
                canActivate={this.state.canReadCountry}
                component={Country}
              />
              <PrivateRoute
                path="/revision-price/country-restrictions"
                canActivate={this.state.canReadCountryRestrict}
                component={CountryRestrictions}
              />
              {/* <PrivateRoute path="/country-sell-price" component={CountrySellPrice} /> */}

              <PrivateRoute
                path="/blacklist"
                canActivate={this.state.canReadBlacklistMgmt}
                component={BlackList}
              />

              <PrivateRoute
                path="/offer"
                canActivate={this.state.canReadOfferMgmt}
                component={OfferManagement}
              />

              <PrivateRoute
                path="/revision-price/listing"
                canActivate={this.state.canReadRevissionPrice}
                component={RevisionListing}
              />
              <PrivateRoute
                path="/revision-price/create"
                canActivate={this.state.canCreateRevissionPrice}
                component={RevisionBuilder}
              />
              <PrivateRoute
                path="/revision-price/edit/:id"
                canActivate={this.state.canUpdateRevissionPrice}
                component={RevisionBuilder}
              />
              <PrivateRoute
                path="/revision-price/:id"
                canActivate={this.state.canReadRevissionPrice}
                component={RevisionDetail}
              />
              {/* <PrivateRoute
                path="/price-management/profit-and-lost"
                component={ProfitAndLost}
              /> */}
              <PrivateRoute
                path="/price-management/cost-listing"
                canActivate={this.state.canReadPriceMgmt}
                component={CostListing}
              />
              <PrivateRoute
                path="/so/list"
                canActivate={this.state.canReadSalesOrder}
                component={SaleOrder}
              />
              <PrivateRoute
                path="/so/create"
                canActivate={this.state.canCreateSalesOrder}
                component={CreateSale}
              />
              <Route component={NotFound} />
            </Switch>
          </Layout>
          {/*<FooterBar />*/}
        </BrowserRouter>
      </Layout>
    );
  }
}

export default MyApp;



// WEBPACK FOOTER //
// ./src/containers/MyApp/index.js